import { countUncompletedSubGoals } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

export const useCreateSubGoalAllowed = () => {
  const goals = useGoals();

  const total = useMemo(() => countUncompletedSubGoals(goals), [goals]);

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(
    LimitKeys.SubGoals,
    {
      totalUncompleted: total,
    },
  );

  return {
    allowed,
    enforced,
    limit,
    total,
  };
};
